import { api } from '@/v2/plugins/axios';

const API_PATH = '/main-order/customers';

class ProfileEntity {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}
	static getProfile = async (id) => {
		return api.get(`${API_PATH}/${id}`);
	};

	static update = async (id, data) => {
		return api.put(`${API_PATH}/${id}`, data);
	};

	static create = async (data) => {
		return api.post(`${API_PATH}`, data).then((res) => res.data?.result?.customer);
	};
}

export default ProfileEntity;
